import type { ButtonHTMLAttributes } from 'react';

import { cx } from '../lib/class-names';

import styles from './Button.module.css';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger';
  /** Shows progress and blocks repeat submissions. */
  busy?: boolean;
}

export function Button({
  variant = 'primary',
  busy = false,
  disabled,
  children,
  className,
  type = 'button',
  ...rest
}: ButtonProps): React.JSX.Element {
  return (
    <button
      {...rest}
      type={type}
      className={cx(styles.button, styles[variant], className)}
      disabled={disabled === true || busy}
      // Announces the pending state without the label text changing under a
      // screen reader mid-sentence.
      aria-busy={busy || undefined}
    >
      {children}
    </button>
  );
}
